export default __webpack_public_path__ + "static/media/PE.03ac98ae.svg";